/**
 * @description Payment method type, e.g. card, bank, paypal.
 */
export enum PaymentCardType {
  MasterCard = 'MasterCard',
  Visa = 'Visa',
  Discover = 'Discover'
}



// WEBPACK FOOTER //
// ./src/model/types/payment-card-type.ts